import axios, { AxiosError, AxiosInstance } from 'axios';
import router from '@/router';
import { userLogout } from '@/utils/user';

const baseURL = process.env.VUE_APP_MICROSERVICE_ACCESS;

const apiClient: AxiosInstance = axios.create({
    baseURL: baseURL,
});

// Добавляем токен ко всем запросам
apiClient.interceptors.request.use(config => {
    const token = localStorage.getItem('token')
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    } else {
        if (localStorage.getItem('logout') && router.currentRoute.value.name !== 'authentication-restore') {
          return Promise.reject(new AxiosError('Unauthorized'));
        }
    }

    return config;
});

// Список запросов, при которых 401 не должно разлогинивать пользователя
const authEndpoints = [
  '/login-test',
  '/login',
  '/api/user-reset-pass/confirm-code',
  '/api/user-reset-pass/phone-input'
];

// Добавляем проверку для ответа 401
apiClient.interceptors.response.use((response) => response, async (error) => {
  const { response, config } = error;

  // Проверяем, что запрос авторизационный (POST и входит в список authEndpoints)
  const isAuthRequest = config?.method === 'post' && authEndpoints.some(url => config.url?.includes(url));

    // Если хоть по одному методу пришел ответ 401, то отправляем на страницу авторизации
    if (response?.status === 401 && !isAuthRequest) {
      userLogout()
    }

    return Promise.reject(error);
  }
);

export default apiClient;